import { EditOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { FC } from 'react'
import FormModal from '../../../../components/form-modal/form-modal'
import Ribbon from '../../../../types/api/ribbon'
import RibbonForm from '../ribbon-form/ribbon-form'

interface EditRibbonProps {
    ribbon: Ribbon
    onSuccess: () => void
}

const EditRibbon: FC<EditRibbonProps> = ({ ribbon, onSuccess }) => {
    return (
        <FormModal
            width={480}
            title={`Риббон №${ribbon.id}`}
            renderOpener={onOpen => (
                <Button
                    size='small'
                    icon={<EditOutlined />}
                    color='primary'
                    variant='outlined'
                    title='Редактировать'
                    onClick={onOpen}
                />
            )}
            renderContent={onClose => (
                <RibbonForm
                    ribbon={ribbon}
                    onSuccess={onSuccess}
                    onClose={onClose}
                />
            )}
        />
    )
}

export default EditRibbon
